import React from 'react';
import { Tag } from 'antd';
import { FormattedMessage } from 'react-intl';

type Status = 'flagged' | 'rejected' | 'confirmed_clean' | null | undefined;

interface StatusBadgeProps {
    status: Status;
}

const STATUS_COLORS: Record<NonNullable<Status>, string> = {
    flagged: 'orange',
    rejected: 'red',
    confirmed_clean: 'green',
};

// Note: rejection_status='flagged' is the "awaiting review" queue state, so it
// shares the unreviewed/awaiting-review label across badge, dropdown, and filter.
// rejection_status=NULL means scored but not flagged for review (clean/suspect
// tier) — render as a neutral dash, not a status badge.
const STATUS_KEYS: Record<NonNullable<Status>, string> = {
    flagged: 'responseIntegrity.status.unreviewed',
    rejected: 'responseIntegrity.status.rejected',
    confirmed_clean: 'responseIntegrity.status.confirmedClean',
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
    if (!status) {
        return (
            <Tag style={{ margin: 0 }}>
                <FormattedMessage id="responseIntegrity.status.notFlagged" />
            </Tag>
        );
    }
    return (
        <Tag color={STATUS_COLORS[status]} style={{ margin: 0 }}>
            <FormattedMessage id={STATUS_KEYS[status]} />
        </Tag>
    );
};
